<template>
	<AppTooltip v-bind="$attrs">
		<SIcon :name="'action-info'" />
		<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope" /></template>
	</AppTooltip>
</template>

<script>
export default {
	name: 'AppInfoTooltipIcon',
};
</script>

<style></style>
